import React, { useState, useEffect, useRef } from "react";
import styles from "./DeviceManager.module.scss";
import { Button, Card, Col, Form, Modal, Row, Spinner, Pagination, Container } from "react-bootstrap";
import { t } from "i18next";
import DataManager from "../../../General/DataManager";
import UserClass from "../../../General/LocalStorage/UserClass";
import Functions from "../../../General/Functions";

const DeviceManager = () => {
    const [applications, setApplications] = useState([]);
    const [selectedApplication, setSelectedApplication] = useState(null);
    const [showModal, setShowModal] = useState(true);
    const [devices, setDevices] = useState([]);
    const [itemsPagination, setItemsPagination] = useState(null);
    const [active, setActive] = useState(1);
    const [deviceUserSelected, setDeviceUserSelected] = useState("");
    const [showEditModal, setShowEditModal] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [DeviceName, setDeviceName] = useState("");
    const [selectedCompanies, setSelectedCompanies] = useState([]);
    const [showSpinner, setShowSpinner] = useState(true);
    const [searchValue, setSearchValue] = useState("");
    const [filter, setFilter] = useState([]);
    const [startIndex, setStartIndex] = useState(null);
    const [endIndex, setEndIndex] = useState(null);
    const [currentPage, setCurrentPage] = useState(null);

    const [primaryCompany, setPrimaryCompany] = useState("");

    useEffect(() => {
        const instance = UserClass.getInstance();
        const userToken = instance.getTokenUser();
        getDeviceApplications(userToken);
    }, []);

    const getDeviceApplications = (token) => {


        DataManager.getApplicationList(token).then((response) => {
            const temp = response?.result?.results || [];
            if (response?.result) {
                const instance = UserClass.getInstance();
                const userInfo = instance.getUser();
                setCompanies(userInfo.companies || []);

                if (userInfo?.role === "SYSADMIN" || userInfo?.role === "DEVICE_MANAGER") {
                    temp.push("TUTTE");
                }
                setApplications(temp);
            } else {
                Functions.alertMsg(response?.msgError || t("msgErrorGeneral"));
            }
        });
    };

    const setApplication = (e) => {
        const app = applications[e.target.selectedIndex - 1];
        setSearchValue("");

        if (app) {

            setTimeout(() => {
                setSelectedApplication(app);
                getListDevices(app);
                setShowModal(false);
            }, 300);
        }
        else {

            setSelectedApplication(null);
            setShowModal(true);

        }
    };

    const getListDevices = (app, name) => {
        const instance = UserClass.getInstance();
        const userToken = instance.getTokenUser();
        if (app === "TUTTE") app = "";

        DataManager.getDevicesList(userToken, app, name).then((response) => {
            if (response?.result) {
                const data = response.result;
                setDevices(data.results);
                setItemsPagination(data.pagination);
                setStartIndex((data.pagination.page - 1) * data.pagination.limit + 1);
                setEndIndex(Math.min(data.pagination.page * data.pagination.limit, data.pagination.total));
                setCurrentPage(data.pagination.page);
            } else {
                Functions.alertMsg(response?.msgError || t("msgErrorGeneral"));
            }
        });
    };

    const getListDevicesPagination = (number) => {
        const app = selectedApplication === "TUTTE" ? "" : selectedApplication;
        const instance = UserClass.getInstance();
        const token = instance.getTokenUser();

        DataManager.getDevicesListPagination(token, app, number, 10, true).then((response) => {
            if (response?.result) {
                const data = response.result;
                setDevices(data.results);
                setItemsPagination(data.pagination);
                setStartIndex((data.pagination.page - 1) * data.pagination.limit + 1);
                setEndIndex(Math.min(data.pagination.page * data.pagination.limit, data.pagination.total));
                setCurrentPage(data.pagination.page);
                setActive(number);
            } else {
                Functions.alertMsg(response?.msgError || t("msgErrorGeneral"));
            }
        });
    };

    const renderColumnTable = () => (
        <thead>
            <tr>
                <th>{t("device_name")}</th>
                <th>{t("udid")}</th>
                <th>{t("application")}</th>
                <th>{t("company")}</th>
                <th>{t("actions")}</th>
            </tr>
        </thead>
    );

    const handleEdit = (item) => {

        setShowEditModal(true);
        setDeviceUserSelected(item);
        setSelectedCompanies(item.companies);
        setPrimaryCompany(
            item.companies?.[0]
        )
        setDeviceName(item.name);

        /*if (deviceUserSelected.application !== "CHECKIN") {
            setSelectedCompanies(item.companies || []);


        }*/
        /*setPrimaryCompany(
            item.primaryCompany || item.companies?.[0] || ""
        );*/

        if (
            item.application === "CHECKIN"
        ) {
            getDeviceCompanies(item)

        }
    };

    const getDeviceCompanies = async (item) => {
        const instance = UserClass.getInstance();
        const token = instance.getTokenUser();

        const response = await DataManager.getDeviceCompanies(token, item?.id);

        if (response?.data) {

            let list;

            if (response?.data?.length > 0) {
                list = response.data.map((c) => ({
                    name: c.name,
                    isSelected: c.isSelected,
                }));


            }
            else {
                list = [{ "name": item?.companies?.[0], "isSelected": true }]

            }
            setSelectedCompanies(list);
            const selected = list.find(c => c.isSelected);
            setPrimaryCompany(selected?.name || "");


            console.log("here", list)

        } else {
            Functions.alertMsg(response?.msgError || t("msgErrorGeneral"));
        }
    };

    const handleAddCompany = (company) => {
        if (deviceUserSelected.application === "CHECKIN") {

            let tempCompany;
            if (!selectedCompanies.some(item => item?.name === company)) {
                if (!primaryCompany) {
                    tempCompany = { "name": company, "isSelected": true };
                    setPrimaryCompany(tempCompany?.name);
                }
                else {
                    tempCompany = { "name": company, "isSelected": false };

                }
                setSelectedCompanies((prev) => [...prev, tempCompany]);

            }

        }
        else {
            if (!selectedCompanies.includes(company)) {
                setSelectedCompanies((prev) => [...prev, company]);

                if (!primaryCompany) {
                    setPrimaryCompany(company);
                }
            }
        }

    };

    const handleRemoveCompany = (company) => {
        let updated;
        if (deviceUserSelected.application === "CHECKIN") {

            let updated = selectedCompanies.filter(
                (c) => c?.name !== company
            );

            let newPrimary = primaryCompany;

            if (primaryCompany === company) {
                newPrimary = updated[0]?.name || "";
                setPrimaryCompany(newPrimary);
            }

            updated = updated.map(item => ({
                ...item,
                isSelected: item.name === newPrimary
            }));

            setSelectedCompanies(updated);
        }
        else {
            updated = selectedCompanies.filter((c) => c !== company);

            setSelectedCompanies(updated);

            if (primaryCompany === company) {
                setPrimaryCompany(updated[0] || "");
            }
        }

    };

    const renderActionSection = (item) => (
        <td key={item.id}>
            <div className="text-center">
                <Button
                    variant="outline-primary"
                    size="sm"
                    className="rounded-pill"
                    onClick={() => handleEdit(item)}
                >
                    <i className="fa fa-edit me-2"></i>
                    {t("edit")}
                </Button>
            </div>
        </td>
    );

    const renderListDevices = () => {
        //const data = searchValue !== "" ? filter : devices;
        const data = devices;
        return (
            <tbody>
                {data.map((item, idx) => (
                    <tr key={idx}>
                        <td>{item.name}</td>
                        <td>{item.udid}</td>
                        <td>{item.application}</td>
                        <td>
                            {item.companies.map((companyName, index) => (
                                <Form.Check
                                    key={index}
                                    type="checkbox"
                                    label={companyName}
                                    checked
                                    disabled
                                />
                            ))}
                        </td>
                        {renderActionSection(item)}
                    </tr>
                ))}
            </tbody>
        );
    };

    const renderPagination = () => {
        if (itemsPagination && searchValue === "") {
            const totalItems = itemsPagination.total;
            const totalPages = Math.ceil(totalItems / itemsPagination.limit);
            const items = [];

            for (let number = 1; number <= totalPages; number++) {
                items.push(
                    <Pagination.Item
                        key={number}
                        active={number === active}
                        onClick={() => getListDevicesPagination(number)}
                    >
                        {number}
                    </Pagination.Item>
                );
            }

            return (
                <div className={`${styles.paginationWrapper} mt-4`}>
                    <div className="small text-muted mb-2 text-center">
                        {t("results")} {startIndex} {t("to")} {endIndex} {t("of")} {itemsPagination?.total}
                    </div>
                    <div className={styles.paginationScroll}>
                        <Pagination className="justify-content-center m-0">
                            <Pagination.First
                                onClick={() => getListDevicesPagination(1)}
                                disabled={currentPage === 1}
                            />
                            <Pagination.Prev
                                onClick={() => getListDevicesPagination(currentPage - 1)}
                                disabled={currentPage === 1}
                            />
                            {items}
                            <Pagination.Next
                                onClick={() => getListDevicesPagination(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            />
                            <Pagination.Last
                                onClick={() => getListDevicesPagination(totalPages)}
                                disabled={currentPage === totalPages}
                            />
                        </Pagination>
                    </div>
                </div>
            );
        }
        return null;
    };


    const handleDeviceUpdate = async () => {

        if (deviceUserSelected.application === "CHECKIN") {

            if (selectedCompanies.length === 0) {
                Functions.alertMsg(t("select_atleast_one"));
                return;
            }
            const hasSelected = selectedCompanies.some(
                item => item.isSelected === true
            );

            if (!hasSelected) {
                Functions.alertMsg(t("select_primary_company"));
                return;
            }

            setShowSpinner(false);

            const instance = UserClass.getInstance();
            const token = instance.getTokenUser();


            const response = await DataManager.updateDeviceCompanies(
                token,
                selectedCompanies,
                deviceUserSelected.id
            );

            if (response?.data) {

                Functions.alertMsgSuccess(t("save_success"));

                getListDevicesPagination(currentPage);

                setShowSpinner(true);

                handleClose();

            } else {

                setShowSpinner(true);

                Functions.alertMsg(
                    response?.msgError || t("msgErrorGeneral")
                );
            }

            return;

        }

        if (selectedCompanies.length === 0) {
            Functions.alertMsg(t("selectonecom"));
            return;
        }
        if (DeviceName === "") {
            Functions.alertMsg(t("devicenameerror"));
            return;
        }

        setShowSpinner(false);
        const instance = UserClass.getInstance();
        const token = instance.getTokenUser();
        const data = { name: DeviceName, companies: selectedCompanies, id: deviceUserSelected.id };

        DataManager.updateDeviceDetails(token, data).then((response) => {
            if (response?.result) {
                Functions.alertMsgSuccess(t("save_success"));
                getListDevicesPagination(currentPage);
                setShowSpinner(true);
                handleClose();
            } else {
                Functions.alertMsg(response?.msgError || t("msgErrorGeneral"));
            }
        });


    };

    const handleClose = () => setShowEditModal(false);
    const handleDeviceNameChange = (event) => setDeviceName(event.target.value);

    const handleSearch = (e) => {
        setSearchValue(e.target.value);
        const filteredRows = devices.filter(
            (row) =>
                row.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
                row.udid.toLowerCase().includes(e.target.value.toLowerCase())
        );
        setFilter(e.target.value.length < 1 ? [] : filteredRows);
    };

    /*const handleSearch2 = (e) => {
        const newValue = e.target.value;
        setSearchValue(newValue);
        if (newValue.length > 3) {
            getListDevices(selectedApplication, newValue);
        }
        else if (newValue === "") {

            getListDevices(selectedApplication);

        }
    }*/
    const searchTimeout = useRef(null);

    const handleSearch2 = (e) => {
        const newValue = e.target.value;
        setSearchValue(newValue);

        clearTimeout(searchTimeout.current);

        searchTimeout.current = setTimeout(() => {
            if (newValue.length > 2) {
                getListDevices(selectedApplication, newValue);
            } else if (newValue === "") {
                getListDevices(selectedApplication);
            }
        }, 300);
    };

    const handleSelectedCompany = (event) => {
        if (deviceUserSelected.application === "CHECKIN") {
            setSelectedCompanies([event.target.value]);
        } else {
            const { value, checked } = event.target;
            setSelectedCompanies((prev) =>
                checked ? [...prev, value] : prev.filter((company) => company !== value)
            );
        }
    };

    const getAppLabel = () => {
        if (deviceUserSelected.application === "CHECKIN") return "CHECKIN";
        if (deviceUserSelected.application === "SUPERVISOR") return "SUPERVISOR";
        return "";
    };

    return (
        <div className={styles.DeviceManager}>
            <Container fluid="md">
                <Card className="p-4 shadow-sm">
                    <Row className="mb-3">
                        <Col xs={12} md={6}>
                            <Form.Label className="fw-semibold">{t("selectapplication")}</Form.Label>
                            <Form.Select size="lg" onChange={setApplication}>
                                <option key="value_null" value={null}>-- {t("select")} --</option>
                                {applications?.map((item, idx) => (
                                    <option key={idx}>{item}</option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>

                    {!showModal && (
                        <>
                            <Row className="mb-4">
                                <Col xs={12} md={6}>
                                    <Form.Label className="fw-semibold">{t("search")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="search"
                                        value={searchValue}
                                        //onChange={handleSearch}
                                        onChange={handleSearch2}
                                        placeholder={"🔍" + t('search_by_name_udid')}
                                    />
                                </Col>
                            </Row>

                            <div className="table-responsive">
                                <table className="table align-middle table-striped table-hover">
                                    {renderColumnTable()}
                                    {renderListDevices()}
                                </table>
                            </div>

                            <div className="mt-3">{renderPagination()}</div>
                        </>
                    )}
                </Card>
            </Container>

            <Modal
                show={showEditModal}
                onHide={handleClose}
                centered
                size="xl"
            >
                <Modal.Header
                    closeButton
                    className="border-0 pb-0 px-4 pt-4"
                >
                    <div>
                        <Modal.Title className="fw-bold fs-4 d-flex align-items-center gap-2">
                            {t("update_device")}

                            {deviceUserSelected.application && (
                                <span
                                    className="badge rounded-pill bg-secondary"
                                    style={{ fontSize: "12px" }}
                                >
                                    {getAppLabel()}
                                </span>
                            )}
                        </Modal.Title>

                        <small className="text-muted">
                            {t("manage_companies_and_primary_assignment")}
                        </small>
                    </div>
                </Modal.Header>
                <Modal.Body className="px-4 py-4">
                    <Form>
                        {/* DEVICE NAME */}
                        <Form.Group className="mb-4">
                            <Form.Label className="fw-semibold text-uppercase small text-muted">
                                {t("device_name")}
                            </Form.Label>

                            <Form.Control
                                type="text"
                                placeholder={t("device_name")}
                                value={DeviceName}
                                onChange={handleDeviceNameChange}
                                className="rounded-4 shadow-sm border-0 py-3"
                                style={{
                                    background: "#f8f9fc",
                                    fontSize: "15px",
                                }}
                            />
                        </Form.Group>

                        {/* COMPANY SELECTOR */}
                        <Row className="g-4">
                            {/* LEFT PANEL */}
                            <Col md={6}>
                                <Card
                                    className="border-0 shadow-sm rounded-4 h-100"
                                    style={{
                                        background: "#f8f9fc",
                                    }}
                                >
                                    <Card.Body>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div>
                                                <h6 className="fw-bold mb-0">
                                                    {t("all_companies")}
                                                </h6>

                                                <small className="text-muted">
                                                    {t("click_to_add")}
                                                </small>
                                            </div>

                                            <div className="badge bg-light text-dark rounded-pill px-3 py-2">
                                                {companies.length}
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                maxHeight: "320px",
                                                overflowY: "auto",
                                            }}
                                        >
                                            {companies.map((company, index) => {
                                                const alreadySelected =
                                                    deviceUserSelected.application === "CHECKIN" ? selectedCompanies?.some(item => item?.name === company) : selectedCompanies.includes(company);

                                                return (
                                                    <div
                                                        key={index}
                                                        onClick={() =>
                                                            !alreadySelected &&
                                                            handleAddCompany(company)
                                                        }
                                                        className="d-flex justify-content-between align-items-center px-3 py-3 mb-2 rounded-4"
                                                        style={{
                                                            cursor: alreadySelected
                                                                ? "default"
                                                                : "pointer",
                                                            background: alreadySelected
                                                                ? "#e9ecef"
                                                                : "#ffffff",
                                                            transition: "all .2s ease",
                                                            border: alreadySelected
                                                                ? "1px solid #dee2e6"
                                                                : "1px solid transparent",
                                                            opacity: alreadySelected ? 0.7 : 1,
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            if (!alreadySelected) {
                                                                e.currentTarget.style.transform =
                                                                    "translateY(-2px)";
                                                                e.currentTarget.style.boxShadow =
                                                                    "0 6px 16px rgba(0,0,0,0.08)";
                                                            }
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.transform =
                                                                "translateY(0)";
                                                            e.currentTarget.style.boxShadow =
                                                                "none";
                                                        }}
                                                    >
                                                        <span className="fw-medium">
                                                            {company}
                                                        </span>

                                                        {!alreadySelected ? (
                                                            <i className="fa fa-plus text-primary"></i>
                                                        ) : (
                                                            <i className="fa fa-check text-success"></i>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>

                            {/* RIGHT PANEL */}
                            <Col md={6}>
                                <Card
                                    className="border-0 shadow-sm rounded-4 h-100"
                                    style={{
                                        background:
                                            "linear-gradient(180deg,#ffffff 0%,#f8f9fc 100%)",
                                    }}
                                >
                                    <Card.Body>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div>
                                                <h6 className="fw-bold mb-0">
                                                    {t("selected_companies")}
                                                </h6>

                                                <small className="text-muted">
                                                    {t("select_primary_company")}
                                                </small>
                                            </div>

                                            <div className="badge bg-primary rounded-pill px-3 py-2">
                                                {selectedCompanies.length}
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                maxHeight: "320px",
                                                overflowY: "auto",
                                            }}
                                        >
                                            {selectedCompanies.length === 0 && (
                                                <div
                                                    className="text-center py-5 rounded-4"
                                                    style={{
                                                        background: "#f8f9fc",
                                                        border: "2px dashed #dee2e6",
                                                    }}
                                                >
                                                    <i className="fa fa-building text-muted mb-3 fs-2"></i>

                                                    <div className="fw-semibold text-muted">
                                                        {t("no_company_selected")}
                                                    </div>

                                                    <small className="text-muted">
                                                        {t("choose_company_from_left")}
                                                    </small>
                                                </div>
                                            )}

                                            {selectedCompanies.map((item, index) => {

                                                const company = deviceUserSelected.application === "CHECKIN" ? item.name : item;
                                                const isSelected = deviceUserSelected.application === "CHECKIN" ? item.isSelected : true;
                                                return (<div
                                                    key={index}
                                                    className="d-flex justify-content-between align-items-center p-3 mb-2 rounded-4 shadow-sm"
                                                    style={{
                                                        background:
                                                            isSelected && deviceUserSelected.application === "CHECKIN"
                                                                ? "linear-gradient(135deg,#0d6efd 0%,#4c8dff 100%)"
                                                                : "#ffffff",
                                                        color:
                                                            isSelected && deviceUserSelected.application === "CHECKIN"
                                                                ? "#fff"
                                                                : "#000",
                                                        transition: "all .2s ease",
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center gap-3">
                                                        <div style={{ width: "24px", display: "flex", justifyContent: "center" }}>
                                                            {deviceUserSelected.application === "CHECKIN" && (
                                                                <Form.Check
                                                                    type="radio"
                                                                    name="primaryCompany"
                                                                    id={`primary-${company}`}
                                                                    checked={primaryCompany === company}
                                                                    onChange={() => {
                                                                        setPrimaryCompany(company)
                                                                        setSelectedCompanies(
                                                                            prev => prev.map(item => ({
                                                                                ...item, isSelected: item.name === company
                                                                            }))
                                                                        )
                                                                    }}
                                                                    className="m-0"
                                                                />
                                                            )}
                                                        </div>

                                                        <div>
                                                            <div className="fw-semibold">
                                                                {company}
                                                            </div>

                                                            {(primaryCompany === company && deviceUserSelected.application === "CHECKIN") && (
                                                                <small
                                                                    style={{
                                                                        opacity: 0.9,
                                                                    }}
                                                                >
                                                                    {t("primary_company")}


                                                                </small>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <Button
                                                        variant={
                                                            deviceUserSelected.application === "CHECKIN" && primaryCompany === company
                                                                ? "light"
                                                                : "outline-danger"
                                                        }
                                                        size="sm"
                                                        className="rounded-circle"
                                                        style={{
                                                            width: "36px",
                                                            height: "36px",
                                                        }}
                                                        onClick={() =>
                                                            handleRemoveCompany(company)
                                                        }
                                                    >
                                                        <i className="fa fa-times"></i>
                                                    </Button>
                                                </div>)
                                            })}
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0 px-4 pb-4 pt-2">
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div>
                            {!showSpinner && (
                                <Spinner animation="border" size="sm" />
                            )}
                        </div>

                        <div className="d-flex gap-2">
                            <Button
                                variant="light"
                                onClick={handleClose}
                                className="rounded-pill px-4"
                            >
                                {t("close")}
                            </Button>

                            <Button
                                variant="primary"
                                onClick={handleDeviceUpdate}
                                className="rounded-pill px-4 shadow-sm"
                            >
                                <i className="fa fa-save me-2"></i>
                                {t("apply")}
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DeviceManager;
